import { render } from "./NewPopupYAML.vue?vue&type=template&id=0312e650&scoped=true"
import script from "./NewPopupYAML.vue?vue&type=script&lang=js"
export * from "./NewPopupYAML.vue?vue&type=script&lang=js"

import "./NewPopupYAML.vue?vue&type=style&index=0&id=0312e650&scoped=true&lang=css"
import "./NewPopupYAML.vue?vue&type=style&index=1&id=0312e650&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0312e650"]])

export default __exports__